export const SALES_ENABLED =
  process.env.REACT_APP_SALES_ENABLED?.trim().toLowerCase() === "true";
